import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Alert, Stack } from '@mui/joy';
import { FaLock, FaArrowLeft, FaHome } from 'react-icons/fa';
import { IconWrapper } from '../components/IconWrapper';

const AccessDeniedPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as { reason?: string; from?: string } | null;
  const reason = state?.reason;
  const from = state?.from;

  const getReasonText = () => {
    switch (reason) {
      case 'not-admin':
        return {
          title: 'Admin Access Required',
          message: 'You need administrator privileges to access this page. Please contact your system administrator if you believe this is an error.',
          color: 'danger' as const
        };
      case 'not-staff':
        return {
          title: 'Staff Access Required',
          message: 'You need staff privileges to access this application. Only authorized staff members can use the Jarvis application.',
          color: 'danger' as const
        };
      default:
        return {
          title: 'Access Denied',
          message: 'You do not have permission to access this page. Please contact your system administrator if you believe this is an error.',
          color: 'danger' as const
        };
    }
  };

  const { title, message, color } = getReasonText();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        p: 3,
        textAlign: 'center'
      }}
    >
      <Stack spacing={3} sx={{ maxWidth: 500, width: '100%' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <IconWrapper 
            icon={FaLock} 
            style={{ 
              fontSize: '4rem', 
              color: `var(--joy-palette-${color}-500)`
            }} 
          />
        </Box>

        <Alert color={color} sx={{ mb: 2 }}>
          {title}
        </Alert>

        <Typography level="h3" mb={2}>
          {title}
        </Typography>

        <Typography level="body-lg" color="neutral" mb={3}>
          {message}
        </Typography>

        <Stack direction="row" spacing={2} justifyContent="center">
          {from && (
            <Button
              variant="outlined"
              startDecorator={<IconWrapper icon={FaArrowLeft} />}
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
          )}
          
          <Button
            variant="solid"
            startDecorator={<IconWrapper icon={FaHome} />}
            onClick={() => navigate('/workspaces')}
          >
            Go to Dashboard
          </Button>
        </Stack>

        {reason && (
          <Typography level="body-sm" color="neutral" mt={2}>
            Error Code: {reason}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default AccessDeniedPage; 